import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { lanternsCardMotion } from './motion';
import { lanternsChromeTone } from './palette';

export const lanternsTheme: FlowThemeDefinition = {
  id: 'lanterns',
  label: 'Lanterns',
  description: 'A paper lantern rises over a twilight lake with every step, then the whole festival lights the night sky.',
  category: 'night',
  chromeTone: lanternsChromeTone,
  swatch: 'linear-gradient(180deg, #2A2766 0%, #5E3F88 45%, #C8688A 75%, #FFB27A 100%)',
  cardGlass: 'dense',
  cardMotion: lanternsCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createLanternsScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
